module.exports = __webpack_public_path__ + "static/media/ic_template_12.fa534305.png";